export default "__VITE_ASSET__CTVj3ZWK__"